import React, { useState } from "react";
import {Box, Card, CardContent, Divider, Grid, Typography} from "@mui/material";
import {ExpandMore, ExpandLess} from "@mui/icons-material";
import {DetailedStatTotals} from "sandy-shared/dist/types/analysis-info.type";

export interface DetailedStatsProps {
  detailedStats: DetailedStatTotals | null;
}

const DetailedStatsCard: React.FC<DetailedStatsProps> = ({detailedStats}) => {
  const [showReceiving, setShowReceiving] = useState(true);
  const [showReceivingErrors, setShowReceivingErrors] = useState(false);
  const [showServing, setShowServing] = useState(true);

  return (
    <div style={{paddingLeft: '25px', paddingRight: '25px', paddingTop: '10px', paddingBottom: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', textAlign: 'center'}}>
      <Card sx={{ minWidth: 300, borderRadius: '10px' }}>
        <CardContent style={{padding: '15px', width: '600px'}}>

          <Box 
            onClick={() => setShowReceiving(!showReceiving)}
            style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}
          >
            <Typography variant="caption" fontSize={16} sx={{ mb: 0.5 }} color="text.secondary">Receiving</Typography>
            {showReceiving ? <ExpandLess fontSize="small" sx={{ mb: 0.5, ml: 1 }} /> : <ExpandMore fontSize="small" sx={{ mb: 0.5, ml: 1 }} />}
          </Box>
          <Divider sx={{ marginBottom: '10px'}}/>

          {showReceiving && (
            <Grid container spacing={1} >
            <Grid item xs={3}>
              <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Typography variant="caption" fontSize={16} color="text.secondary">Sideout %</Typography>
                <Typography variant="h4" component="div">{detailedStats?.individual?.sideoutPercentage?.toFixed(3) ?? 'NA'}</Typography>
                <Typography variant="caption" fontSize={14} color="text.secondary">({detailedStats?.individual?.successfulSideouts ?? 0} / {(detailedStats?.individual?.sideoutOpportunities ?? 0)})</Typography>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Typography variant="caption" fontSize={16} color="text.secondary">FB Sideout %</Typography>
                <Typography variant="h4" component="div">{detailedStats?.individual?.fbSideoutPercentage?.toFixed(3) ?? 'NA'}</Typography>
                <Typography variant="caption" fontSize={14} color="text.secondary">({detailedStats?.individual?.totalKills ?? 0} / {(detailedStats?.individual?.sideoutOpportunities ?? 0)})</Typography>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Typography variant="caption" fontSize={16}  color="text.secondary">FB Efficiency %</Typography>
                <Typography variant="h4" component="div">{detailedStats?.individual?.fbEfficiency?.toFixed(3) ?? 'NA'}</Typography>
                <Typography variant="caption" fontSize={14} color="text.secondary"> (+{detailedStats?.individual?.totalKills ?? 0} / -{(detailedStats?.individual?.totalErrorsAndAced ?? 0)} / {(detailedStats?.individual?.sideoutOpportunities ?? 0)})</Typography>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Typography variant="caption" fontSize={16} color="text.secondary">Trans. Win %</Typography>
                <Typography variant="h4" component="div">{detailedStats?.individual?.receiveTransitionPointWinPercentage?.toFixed(3) ?? 'NA'}</Typography>
                <Typography variant="caption" fontSize={14} color="text.secondary">({detailedStats?.individual?.receiveTransitionPointsWon ?? 0} / {(detailedStats?.individual?.receiveTransitionPointsWon ?? 0) + (detailedStats?.individual?.receiveTransitionPointsLost ?? 0)})</Typography>
              </Box>
            </Grid>
            </Grid>
          )}

          <Box 
            onClick={() => setShowReceivingErrors(!showReceivingErrors)}
            style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: '10px', cursor: 'pointer'}}
          >
            <Typography variant="caption" fontSize={16} sx={{ mb: 0.5 }} color="text.secondary">Receiving Errors</Typography>
            {showReceivingErrors ? <ExpandLess fontSize="small" sx={{ mb: 0.5, ml: 1 }} /> : <ExpandMore fontSize="small" sx={{ mb: 0.5, ml: 1 }} />}
          </Box>
          <Divider sx={{ marginBottom: '10px'}}/>

          {showReceivingErrors && (
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <Typography variant="caption" fontSize={16} sx={{ mb: 1.5 }} color="text.secondary">Aced</Typography>
                <Typography variant="h4" component="div">{detailedStats?.individual?.aced ?? 'NA'}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" fontSize={16} sx={{ mb: 1.5 }} color="text.secondary">Blocked</Typography>
                <Typography variant="h4" component="div">{detailedStats?.individual?.blocked ?? 'NA'}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" fontSize={16} sx={{ mb: 1.5 }} color="text.secondary">Net Swings</Typography>
                <Typography variant="h4" component="div">{detailedStats?.individual?.netSwings ?? 'NA'}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" fontSize={16} sx={{ mb: 1.5 }} color="text.secondary">Own Faults</Typography>
                <Typography variant="h4" component="div">{detailedStats?.individual?.ownFaults ?? 'NA'}</Typography>
              </Grid>
            </Grid>
          )}

          <Box 
            onClick={() => setShowServing(!showServing)}
            style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}
          >
            <Typography variant="caption" fontSize={16} sx={{ mb: 0.5 }} color="text.secondary">Serving</Typography>
            {showServing ? <ExpandLess fontSize="small" sx={{ mb: 0.5, ml: 1 }} /> : <ExpandMore fontSize="small" sx={{ mb: 0.5, ml: 1 }} />}
          </Box>
          <Divider sx={{ marginBottom: '10px'}}/>

          {showServing && (
            <Grid container spacing={1}>
            <Grid item xs={3}>
              <Typography variant="caption" fontSize={16} sx={{ mb: 1.5 }} color="text.secondary">Knockout %</Typography>
              <Typography variant="h4" component="div">{detailedStats?.individual?.serveKnockoutPercentage?.toFixed(3) ?? 'NA'}</Typography>
              <Typography variant="caption" fontSize={14} color="text.secondary">({(detailedStats?.individual?.opponentOutOfSystemPasses ?? 0) + (detailedStats?.individual?.aces ?? 0)} / {(detailedStats?.individual?.totalServes ?? 0)})</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" fontSize={16} sx={{ mb: 1.5 }} color="text.secondary">Ace %</Typography>
              <Typography variant="h4" component="div">{detailedStats?.individual?.acePercentage?.toFixed(3) ?? 'NA'}</Typography>
              <Typography variant="caption" fontSize={14} color="text.secondary">({detailedStats?.individual?.aces ?? 0} / {(detailedStats?.individual?.totalServes ?? 0)})</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" fontSize={16} sx={{ mb: 1.5 }} color="text.secondary">Efficiency %</Typography>
              <Typography variant="h4" component="div">{detailedStats?.individual?.serveEfficiencyPercentage?.toFixed(3) ?? 'NA'}</Typography>
              <Typography variant="caption" fontSize={14} color="text.secondary"> (+{detailedStats?.individual?.knockoutServes ?? 0} / -{(detailedStats?.individual?.serviceErrors ?? 0)} / {(detailedStats?.individual?.totalServes ?? 0)})</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" fontSize={16} sx={{ mb: 1.5 }} color="text.secondary">Trans. Win %</Typography>
              <Typography variant="h4" component="div">{detailedStats?.individual?.serveTransitionPointWinPercentage?.toFixed(3) ?? 'NA'}</Typography>
              <Typography variant="caption" fontSize={14} color="text.secondary">({detailedStats?.individual?.serveTransitionPointsWon ?? 0} / {(detailedStats?.individual?.totalServeTransitionPoints ?? 0)})</Typography>
            </Grid>
            </Grid>
          )}

        </CardContent>
      </Card>
    </div>
  );
};

export default DetailedStatsCard;
